import React, { useState } from 'react'
import CarDeliveryStamp from '@/modern/components/Stamps/CarDelivery'
import Icon from '@/modern/components/Icon'
import * as S from '../style'

const url =
  'https://www.webmotors.com.br/cardelivery/?idcmpint=t1:c17:m07:portal-anuncio-lpcardelivery:cardelivery::saiba-mais:comprar'

const dataTestLabel = 'tooltip_cardelivery'

export default function CarDelivery() {
  const [hover, setHover] = useState(false)
  return (
    <S.SealArea
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      hover={hover}
    >
      <S.SealHeader data-test-component={dataTestLabel}>
        <CarDeliveryStamp daInfo />
        <S.StampText>CarDelivery</S.StampText>
        <Icon name="Arrow_6" fill="#2E2D37" size="25" />
      </S.SealHeader>
      <S.Tooltip hover={hover}>
        <S.StrongText>
          Compre online: &nbsp;
          <S.Description>
            a loja cuida da documentação, você faz o test-drive e recebe o carro
            em casa!
          </S.Description>
        </S.StrongText>

        <S.Link href={url} target="_blank">
          Conheça
        </S.Link>
      </S.Tooltip>
    </S.SealArea>
  )
}
